const comments = [
  {
    name: '影视达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20person%20portrait%20style%20avatar%2C%20warm%20smiling%20face%2C%20clean%20minimal%20background%2C%20soft%20natural%20lighting%2C%20professional%20casual%20look&width=80&height=80&seq=avatar-user-1&orientation=squarish',
    text: '用了糖心视频半年多了，资源真的很全！之前要在好几个APP之间切换找想看的剧，现在一个网站就搞定了。更新速度也很快，热播剧基本和平台同步。',
    time: '2天前',
    source: '西瓜视频用户',
  },
  {
    name: '追剧小能手',
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20female%20portrait%20style%20avatar%2C%20warm%20expression%2C%20clean%20simple%20background%2C%20soft%20lighting%2C%20casual%20modern%20look&width=80&height=80&seq=avatar-user-2&orientation=squarish',
    text: '画质真的没话说，1080P超清还不用缓冲，比某些需要会员的网站体验还好。最赞的是不用注册，打开就能看，太方便了！已经推荐给身边所有朋友了。',
    time: '5天前',
    source: '樱花视频用户',
  },
  {
    name: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20person%20portrait%20style%20avatar%20with%20glasses%2C%20friendly%20look%2C%20clean%20minimal%20background%2C%20warm%20lighting%2C%20intellectual%20casual%20style&width=80&height=80&seq=avatar-user-3&orientation=squarish',
    text: '作为一个纪录片爱好者，糖心视频的纪录片专区真的太棒了。《地球脉动III》4K画质看着简直是享受，而且还有中文字幕。每天晚上睡前看一集，涨知识又放松。',
    time: '1周前',
    source: '糖豆视频用户',
  },
  {
    name: '番剧猎人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20stylish%20young%20Chinese%20person%20portrait%20style%20avatar%2C%20cool%20expression%2C%20clean%20simple%20background%2C%20soft%20lighting%2C%20modern%20urban%20style&width=80&height=80&seq=avatar-user-4&orientation=squarish',
    text: '动漫区的资源太全了！《鬼灭之刃》全系列都有，而且更新的比某些专门追番的网站还快。画质清晰，翻译质量也好，已经成了我的主力追番平台。',
    time: '2周前',
    source: '樱桃视频用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm font-medium text-secondary-500 uppercase tracking-wide mb-2">用户评价</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">观众都在说</h2>
          <p className="mt-2 text-sm text-foreground-500">来自真实用户的观影体验分享</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {comments.map((comment, idx) => (
            <div key={idx} className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-300">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400 mt-0.5">{comment.time} · {comment.source}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              <div className="mt-3 flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}